/* tslint:disable */

/**
 */
export class Denomination {
    price?: number;
    type?: string;
    color?: string;
}
